import { render, staticRenderFns } from "./LogworkHourBar.vue?vue&type=template&id=058872b6&scoped=true&"
import script from "./LogworkHourBar.vue?vue&type=script&lang=js&"
export * from "./LogworkHourBar.vue?vue&type=script&lang=js&"
import style0 from "./LogworkHourBar.vue?vue&type=style&index=0&id=058872b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058872b6",
  null
  
)

export default component.exports